<template>
  <div>
    <nav class="navbar is-dark">
      <div class="navbar-brand">
        <a class="navbar-item" @click="goToFilter(mainItem, null)"><img src="../../assets/logoKDCAbox-white.svg"
            class="logo"></a>
        <div :class="hamburguerClass" @click="toggleHamburguer">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div :class="navBarClass">
        <div class="navbar-start">

        </div>

        <div class="navbar-end">
          <div v-for="item in routes" :key="item.path" class="navbar-item has-dropdown is-hoverable">
            <a :class="'navbar-link'" @click="goToFilter(item, null)">
              {{ item.name }}
            </a>
            <div class="navbar-dropdown is-boxed">
              <a class="navbar-item" v-if="item.name !== 'Contactos'" @click="goToFilter(item, null)">
                {{ CONSTANTS.getCopy('NAVBAR_CONTACTS_ALL') }}
              </a>
              <hr class="navbar-divider" v-if="item.name !== 'Contactos'">
              <a v-for="client in clients" :key="client.idClient" class="navbar-item" @click="goToFilter(item, client)">
                {{ client.name }}
              </a>
            </div>
          </div>
          <div v-if="idProject === 'P3rw1Un80Yz3'" class="navbar-item has-dropdown is-hoverable">
            <a @click="goToRestaurantsScreen" class="navbar-link">{{ CONSTANTS.getCopy('NAVBAR_RESTAURANTS') }}</a>
          </div>
          <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link">
              {{ userName }}
            </a>
            <div class="navbar-dropdown is-boxed">
              <a class="navbar-item" @click="setLanguage('es')">
                Español
              </a>
              <a class="navbar-item" @click="setLanguage('pt')">
                Português
              </a>
              <a class="navbar-item" @click="logout">
                {{ CONSTANTS.getCopy('NAVBAR_LOG_OUT') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>

  </div>

</template>

<script>
import Auth from '../../models/auth'
import CONSTANTS from '../../constants'

export default {
  data () {
    return {
      menuActive: false,
      hide: true,
      items: [],
      mainItem: null,
      user: {
        'name': null
      },
      clients: [],
      path: null,
      idProject: localStorage.getObject('user.idProject')
    }
  },

  created () {
    this.setRoutes()
    this.getClients()
  },

  computed: {
    routes () {
      return this.items
    },
    isAdmin () {
      return Auth.isAdmin()
    },
    hamburguerClass () {
      return this.menuActive ? 'navbar-burger burger is-active' : 'navbar-burger burger'
    },
    navBarClass () {
      return this.menuActive ? 'navbar-menu is-active' : 'navbar-menu burger'
    },
    userName () {
      return localStorage.getObject('user.name', false)
    }
  },

  methods: {
    toggleHamburguer () {
      this.menuActive = !this.menuActive
    },
    toggleModal () {
      this.showModal = !this.showModal
    },
    isActive (item) {
      return this.$route.path === item.path
    },
    logout () {
      // this.auth.logout()
      Auth.deleteAuthorization()
      this.$router.push('/login')
    },
    setRoutes () {
      if (Auth.isAdmin()) this.items.push({name: CONSTANTS.getCopy('NAVBAR_ITEM_CHATBOTS'), path: '/clients'})
      if (Auth.isAdmin()) this.items.push({name: CONSTANTS.getCopy('NAVBAR_ITEM_TRAINING'), path: '/training'})
      if (!Auth.isAgent()) this.items.push({name: CONSTANTS.getCopy('NAVBAR_ITEM_CONTACTS'), path: '/contacts'})
      this.items.push({name: CONSTANTS.getCopy('NAVBAR_ITEM_CONVERSATIONS'), path: '/chats'})
      if (Auth.isAdmin()) this.items.push({name: 'Widgets', path: '/widget'})
      if (!Auth.isAgent()) this.items.push({name: CONSTANTS.getCopy('NAVBAR_ITEM_METRICS'), path: '/analytics'})
      this.mainItem = this.items[0]
    },
    getClients () {
      this.api.post('/ClientGetList').then(response => {
        this.clients = response.clients
      })
    },
    setLanguage (language) {
      localStorage.setItem('language', language)
      this.$router.go()
    },
    goToFilter (item, client) {
      this.path = item.path
      if (client && Auth.isAdmin()) {
        if (item.path === '/clients') {
          this.path = item.path + '/' + client.idClient + '/intents'
        } else {
          this.path = '/clients/' + client.idClient + item.path
        }
      }
      if (client && (Auth.isAgent() || Auth.isResponsible())) this.path = '/clients/' + client.idClient + item.path
      if (this.path === '/contacts') return
      console.log(this.path)
      this.$router.push(this.path)
      window.location.reload()
    },
    goToRestaurantsScreen () {
      this.$router.push('/restaurants')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/NavBar.vue